import { render, staticRenderFns } from "./AtencionImagenes.vue?vue&type=template&id=abfd5a00"
import script from "./AtencionImagenes.vue?vue&type=script&lang=js"
export * from "./AtencionImagenes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports